// Builds the set of report-param keys a question owns, each set to null - the shape the page's
// param store takes to clear a question's sections. Each block declares which prefixes it owns;
// the key grammar itself lives here.

const positions = items => (items || []).filter(Boolean).map(item => item.position)

const wcKey = key => String(key).replace(/\./g, '-')

const paramKey = (prefix, key) => ('wc' === prefix ? `wc${wcKey(key)}` : `${prefix}${key}`)

const subItemKey = (prefix, key, position) =>
  'wc' === prefix ? `wc${wcKey(key)}-${position}` : `${prefix}${key}.${position}`

// Two single-occurrence replaces, so only the first dot is swapped - this reproduces the keys the
// word cloud actually wrote. A global replace would build keys that match nothing.
const clusterToken = uid => String(uid).replace('@', '_').replace('.', '_')

export const calcQuestionClearParams = ({
  questionKey,
  answerVariants,
  batches,
  clusters,
  question = [],
  subItem = []
} = {}) => {
  const params = {}
  if (null == questionKey) return params

  const key = String(questionKey)

  for (const prefix of question) params[paramKey(prefix, key)] = null

  for (const position of [...positions(answerVariants), ...positions(batches)]) {
    for (const prefix of subItem) params[subItemKey(prefix, key, position)] = null
  }

  for (const cluster of clusters || []) {
    if (cluster?.uid != null) params[`wc${wcKey(key)}-${clusterToken(cluster.uid)}`] = null
  }

  return params
}
